import styled from 'styled-components';

export default styled.span`
    .header {
        position: static !important;
    }

    a {
        text-decoration: none !important;
    }
`;
